interface TextOnlyButtonProps {
  title: string;
}

const TextOnlyButton = ({ title }: TextOnlyButtonProps) => {
  return <>{title}</>;
};

export default TextOnlyButton;
